import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const userExtendSessionReq = (config: any, req: any) => {
  const request: Request<{}> = {
    config: config,
    apiPath: APIEndPoints.userSessionExtend,
    method: 'POST',
    body: req,
  }
  return executeRequest(request).then((data) => {
    return responseParser(data)
  })
}

export { userExtendSessionReq }
